export const AREA_CODES = [
  '+852',
  '+886',
  '+81'
];